import { render, staticRenderFns } from "./Opsview.vue?vue&type=template&id=f1accaa0&scoped=true&"
import script from "./Opsview.vue?vue&type=script&lang=js&"
export * from "./Opsview.vue?vue&type=script&lang=js&"
import style0 from "./Opsview.vue?vue&type=style&index=0&id=f1accaa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1accaa0",
  null
  
)

export default component.exports